<template>
    <div >
       
        <s-button 
            :label="valueSelected"
            @onclick="open=true"
            afterIcon="caret-square-down"
            :theme="theme"  
        />
        <s-modal
            :open="open"
            @close="close"
            :close="true"
        >
            <div v-for="(valueItem, indexValue) in values" class="item" >
                <div style="float:left">
                    <s-button icon="hand-pointer" label="" @onclick="selectValue(valueItem.id)" theme="is-primary is-small"/>
                </div>
                <div  style="float:left;width: 60%;text-align:left">
                <s-input theme="is-primary is-small" v-model="values[indexValue].label"  />
                </div>
                
                <div style="float:right">
                    <s-button 
                        :disabled="indexValue==0"
                        icon="arrow-up" @onclick="up(indexValue)" theme="is-small is-primary" label=""/>
                        &nbsp;
                    <s-button
                    :disabled="indexValue==values.length-1"
                    icon="arrow-down" @onclick="down(indexValue)" theme="is-small is-primary" label=""/>
                    &nbsp;
                    <s-button icon="trash" @onclick="deleteValue(indexValue)" theme="is-small is-danger" label="" />
                </div>
            </div>
            <div class="formAdd">
                <s-input type="text" width="200px" theme="is-success is-small" v-model="addValue"/>
                 &nbsp;&nbsp;   <s-button icon="plus" @onclick="setValue()" theme="is-small is-success" label="" />
            </div>
        </s-modal>
    </div>
</template>
<style scoped>
  
    .item {
        border: thin black solid;
        
        margin: 10px;
        height: 50px;
    }
    .item div {
        display: inline-block;
        padding: 10px;
    }
   
</style>
<script>
export default {
    props: ["values", "value", "theme"],
    data() {
        return {
            open: false,
            addValue: ""
        }
    },
    computed: {
        valueSelected: {
            get() {
                if (this.value!=null) {
                    if (typeof(this.values.find(elt=>elt.id===this.value)) != "undefined")
                        return this.values.find(elt=>elt.id===this.value).label
                }
                return 'non défini'
            }
        }
    },
    methods:{
        up(index) {
            var valueInsere = this.values[index];
             this.values.splice(parseInt(index), 1);
            this.values.splice(parseInt(index)-1, 0, valueInsere);
            this.$emit('save');
        },
        down(index) {
            var valueInsere = this.values[index];
            this.values.splice(index, 1);
             this.values.splice(parseInt(index)+1, 0, valueInsere);
            this.$emit('save');
        },
        selectValue(param) {
            this.$emit('select', param);
            this.close();
        },
        deleteValue(param) {
            this.$emit('delete', param);
        },
        setValue() {
            this.$emit('add', this.addValue);
        },
        changeValues(param) {
            console.log(param)
            console.log(this.values);
            this.$emit(this.values);
        },
        close() {
            this.open = false;
            this.$emit('close');
        }
    }
}
</script>